import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProfileOverview from "./profile/ProfileOverview";
import ProfileOverviewUser from "./profile/ProfileOverviewUser";
import Login from "./signin/Login";
import RegisterSteps from "./profile/RegisterSteps";
import Signin from "./signin/SignIn";
import ForgotPassword from "../pages/ForgotPassword"
import ResetPassword from "../pages/ResetPassword";

function UnAuthenticatedRoutes(props) {
  const Landing = lazy(() => import("../pages/Landing"));
  const Live = lazy(() => import("../pages/Live"));
  const Host = lazy(() => import("../pages/Host"));
  const Watch = lazy(() => import("../pages/Watch"));
 

  return (
    <Suspense fallback={<p></p>}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/forgot/password" element={<ForgotPassword />} />
          <Route path="/reset/password" element={<ResetPassword />} />
          <Route path="/register/:id?" element={<RegisterSteps />} />
          <Route path="/view-profile/:id" element={<ProfileOverview />} />
          <Route path="/login" element={<Signin />} />

          {/* livestream routes */}
          <Route path="/live" element={<Live />} />
          <Route path="/channel/:id" element={<Watch />} />
          <Route path="/channel/:id/host" element={<Host />} />

           {/* landing routes */}
          <Route path="/*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default UnAuthenticatedRoutes;
